import { IconVariant } from './IconVariant';
import { Airfryer } from './illustrated/Airfryer';
import { AntiInflamitory } from './illustrated/AntiInflamitory';
import { BeansPlusLentils } from './illustrated/BeansPlusLentils';
import { Beef } from './illustrated/Beef';
import { Beets } from './illustrated/Beets';
import { BellPepper } from './illustrated/BellPepper';
import { Blender } from './illustrated/Blender';
import { Breakfast } from './illustrated/Breakfast';
import { Burger } from './illustrated/Burger';
import { CaffeineFree } from './illustrated/CaffeineFree';
import { Calendar as CalendarUtility, Calendar } from './illustrated/Calendar';
import { CalorieConscious } from './illustrated/CalorieConscious';
import { Calories } from './illustrated/Calories';
import { ChefsPick } from './illustrated/ChefsPick';
import { Chicken } from './illustrated/Chicken';
import { Cilantro } from './illustrated/Cilantro';
import { Coconut } from './illustrated/Coconut';
import { Credit } from './illustrated/Credit';
import { Crockpot } from './illustrated/Crockpot';
import { Cuisines } from './illustrated/Cuisines';
import { Cyo } from './illustrated/Cyo';
import { DairyFree } from './illustrated/DairyFree';
import { DairyFreeCheese } from './illustrated/DairyFreeCheese';
import { Dietary } from './illustrated/Dietary';
import { Dislike } from './illustrated/Dislike';
import { EggFree } from './illustrated/EggFree';
import { Eggplant } from './illustrated/Eggplant';
import { Feeds1 } from './illustrated/Feeds1';
import { Feeds2 } from './illustrated/Feeds2';
import { Feeds3 } from './illustrated/Feeds3';
import { Feeds4 } from './illustrated/Feeds4';
import { Flavors } from './illustrated/Flavors';
import { FreeShipping } from './illustrated/FreeShipping';
import { FreshFish } from './illustrated/FreshFish';
import { Garlic } from './illustrated/Garlic';
import { GarlicFree } from './illustrated/GarlicFree';
import { Gift } from './illustrated/Gift';
import { GlutenFree } from './illustrated/GlutenFree';
import { GlutenFreeBread } from './illustrated/GlutenFreeBread';
import { GrainFree } from './illustrated/GrainFree';
import { Grill } from './illustrated/Grill';
import { GutFriendly } from './illustrated/GutFriendly';
import { GutHealth } from './illustrated/GutHealth';
import { HighFiber } from './illustrated/HighFiber';
import { HighProtein } from './illustrated/HighProtein';
import { IllustrationDietary } from './illustrated/IllustrationDietary';
import { Immunity } from './illustrated/Immunity';
import { KidsSnacks } from './illustrated/KidsSnacks';
import { Lamb } from './illustrated/Lamb';
import { Lightbulb } from './illustrated/Lightbulb';
import { LowCarb } from './illustrated/LowCarb';
import { LowCholesterol } from './illustrated/LowCholesterol';
import { LowFat } from './illustrated/LowFat';
import { LowFodmap } from './illustrated/LowFodmap';
import { LowSodium } from './illustrated/LowSodium';
import { LowSugar } from './illustrated/LowSugar';
import { Microwave } from './illustrated/Microwave';
import { Mushrooms } from './illustrated/Mushrooms';
import { NoBellPepper } from './illustrated/NoBellPepper';
import { NoCilantro } from './illustrated/NoCilantro';
import { NoEggplant } from './illustrated/NoEggplant';
import { NoMushrooms } from './illustrated/NoMushrooms';
import { None } from './illustrated/None';
import { NoOnion } from './illustrated/NoOnion';
import { NoPotatoes } from './illustrated/NoPotatoes';
import { NoTomatoes } from './illustrated/NoTomatoes';
import { Nutrition } from './illustrated/Nutrition';
import { Onion } from './illustrated/Onion';
import { OnionFree } from './illustrated/OnionFree';
import { OpenBox } from './illustrated/OpenBox';
import { Organic } from './illustrated/Organic';
import { Organic2 } from './illustrated/Organic2';
import { Oven } from './illustrated/Oven';
import { PeanutFree } from './illustrated/PeanutFree';
import { Personalized } from './illustrated/Personalized';
import { Pescatarian } from './illustrated/Pescatarian';
import { PlantBased } from './illustrated/PlantBased';
import { PlantBasedEgg } from './illustrated/PlantBasedEgg';
import { Polarizing } from './illustrated/Polarizing';
import { Pork } from './illustrated/Pork';
import { Potatoes } from './illustrated/Potatoes';
import { Protein } from './illustrated/Protein';
import { Recent } from './illustrated/Recent';
import { Recipe } from './illustrated/Recipe';
import { SesameFree } from './illustrated/SesameFree';
import { Shellfish } from './illustrated/Shellfish';
import { ShellfishFree } from './illustrated/ShellfishFree';
import { SmokedFish } from './illustrated/SmokedFish';
import { Snacks } from './illustrated/Snacks';
import { SnacksLarge } from './illustrated/SnacksLarge';
import { SnacksMedium } from './illustrated/SnacksMedium';
import { SnacksSmall } from './illustrated/SnacksSmall';
import { SoyFree } from './illustrated/SoyFree';
import { SpendMoreSaveMore } from './illustrated/SpendMoreSaveMore';
import { Spice } from './illustrated/Spice';
import { SpiceHot } from './illustrated/SpiceHot';
import { SpiceMedium } from './illustrated/SpiceMedium';
import { SpiceMild } from './illustrated/SpiceMild';
import { SpiceNone } from './illustrated/SpiceNone';
import { Stove } from './illustrated/Stove';
import { StoveTop } from './illustrated/StoveTop';
import { Sweets } from './illustrated/Sweets';
import { Sweets2 } from './illustrated/Sweets2';
import { Sweets23 } from './illustrated/Sweets23';
import { Sweets46 } from './illustrated/Sweets46';
import { Sweets710 } from './illustrated/Sweets710';
import { TableSetting } from './illustrated/TableSetting';
import { Tempeh } from './illustrated/Tempeh';
import { ThirtyOff } from './illustrated/ThirtyOff';
import { Tomatoes } from './illustrated/Tomatoes';
import { TreeNutFree } from './illustrated/TreeNutFree';
import { Vegan } from './illustrated/Vegan';
import { Vegetarian } from './illustrated/Vegetarian';
import { WalletIllustrated } from './illustrated/WalletIllustrated';

import { Apple } from './utility/Apple';
import { ArrowLeft } from './utility/ArrowLeft';
import { ArrowRight } from './utility/ArrowRight';
import { ArrowRightNew } from './utility/ArrowRightNew';
import { Bookmark } from './utility/Bookmark';
import { Box } from './utility/Box';
import { CalendarOutline } from './utility/CalendarOutline';
import { CaretDown } from './utility/CaretDown';
import { CaretDownNew } from './utility/CaretDownNew';
import { CaretLeft } from './utility/CaretLeft';
import { CaretRight } from './utility/CaretRight';
import { CaretUp } from './utility/CaretUp';
import { Cart } from './utility/Cart';
import { Cart2 } from './utility/Cart2';
import { Chain } from './utility/Chain';
import { Check } from './utility/Check';
import { CheckboxOff } from './utility/CheckboxOff';
import { CheckboxOn } from './utility/CheckboxOn';
import { Checklist } from './utility/Checklist';
import { ChefHat } from './utility/ChefHat';
import { Clock as ClockIllustrated, Clock } from './utility/Clock';
import { Coin } from './utility/Coin';
import { Coin2 } from './utility/Coin2';
import { Facebook } from './utility/Facebook';
import { FilterBadge } from './utility/FilterBadge';
import { FilterBadgeActive } from './utility/FilterBadgeActive';
import { Fish } from './utility/Fish';
import { Flame } from './utility/Flame';
import { Fridge } from './utility/Fridge';
import { Gear } from './utility/Gear';
import { Google } from './utility/Google';
import { Heart } from './utility/Heart';
import { Home } from './utility/Home';
import { HomeFilled } from './utility/HomeFilled';
import { Information } from './utility/Information';
import { Instagram } from './utility/Instagram';
import { List } from './utility/List';
import { ListFilled } from './utility/ListFilled';
import { Lock } from './utility/Lock';
import { MagnifyingGlass } from './utility/MagnifyingGlass';
import { MagnifyingGlassFilled } from './utility/MagnifyingGlassFilled';
import { Minus } from './utility/Minus';
import { Never } from './utility/Never';
import { New as NewIllustrated, New } from './utility/New';
import { Pause } from './utility/Pause';
import { Pencil } from './utility/Pencil';
import { Pepper } from './utility/Pepper';
import { Pepper2 } from './utility/Pepper2';
import { Person } from './utility/Person';
import { PersonFilled } from './utility/PersonFilled';
import { Platter } from './utility/Platter';
import { Play } from './utility/Play';
import { Plus } from './utility/Plus';
import { PlusCircle } from './utility/PlusCircle';
import { Question } from './utility/Question';
import { RadioOff } from './utility/RadioOff';
import { RadioOn } from './utility/RadioOn';
import { Servings } from './utility/Servings';
import { Slider } from './utility/Slider';
import { Sparkle } from './utility/Sparkle';
import { StarFill } from './utility/StarFill';
import { StarOutline } from './utility/StarOutline';
import { Sunrise } from './utility/Sunrise';
import { Swap } from './utility/Swap';
import { Tag } from './utility/Tag';
import { ThumbsDown } from './utility/ThumbsDown';
import { ThumbsDownFilled } from './utility/ThumbsDownFilled';
import { ThumbsUp } from './utility/ThumbsUp';
import { ThumbsUpFilled } from './utility/ThumbsUpFilled';
import { Trash } from './utility/Trash';
import { Trash2 } from './utility/Trash2';
import { Truck } from './utility/Truck';
import { Twitter } from './utility/Twitter';
import { Vegan2 } from './utility/Vegan2';
import { Vegetarian2 } from './utility/Vegetarian2';
import { Wallet } from './utility/Wallet';
import { Warning } from './utility/Warning';
import { X } from './utility/X';
import { XCircle } from './utility/XCircle';
import { Youtube } from './utility/Youtube';

export interface IconProps {
  variant: IconVariant;
}

/**
 * @deprecated Import the Icon component itself from `@hungryroot/ui-kit` instead.
 *             For example, just import `SnacksLarge` instead of using this component to render the SnacksLarge icon.
 */
export function Icon(props: IconProps) {
  const { variant } = props;
  switch (variant) {
    case IconVariant.SnacksLarge:
      return <SnacksLarge />;
    case IconVariant.SnacksMedium:
      return <SnacksMedium />;
    case IconVariant.SnacksSmall:
      return <SnacksSmall />;
    case IconVariant.Apple:
      return <Apple />;
    case IconVariant.ArrowLeft:
      return <ArrowLeft />;
    case IconVariant.ArrowRight:
      return <ArrowRight />;
    case IconVariant.ArrowRightNew:
      return <ArrowRightNew />;
    case IconVariant.Box:
      return <Box />;
    case IconVariant.CalendarUtility:
      return <CalendarUtility />;
    case IconVariant.CalendarOutline:
      return <CalendarOutline />;
    case IconVariant.CaretDown:
      return <CaretDown />;
    case IconVariant.CaretDownNew:
      return <CaretDownNew />;
    case IconVariant.CaretLeft:
      return <CaretLeft />;
    case IconVariant.CaretRight:
      return <CaretRight />;
    case IconVariant.CaretUp:
      return <CaretUp />;
    case IconVariant.Cart:
      return <Cart />;
    case IconVariant.Cart2:
      return <Cart2 />;
    case IconVariant.Chain:
      return <Chain />;
    case IconVariant.Check:
      return <Check />;
    case IconVariant.CheckboxOff:
      return <CheckboxOff />;
    case IconVariant.CheckboxOn:
      return <CheckboxOn />;
    case IconVariant.Checklist:
      return <Checklist />;
    case IconVariant.Clock:
      return <Clock />;
    case IconVariant.Coin:
      return <Coin />;
    case IconVariant.Coin2:
      return <Coin2 />;
    case IconVariant.Facebook:
      return <Facebook />;
    case IconVariant.FilterBadge:
      return <FilterBadge />;
    case IconVariant.FilterBadgeActive:
      return <FilterBadgeActive />;
    case IconVariant.Flame:
      return <Flame />;
    case IconVariant.Fridge:
      return <Fridge />;
    case IconVariant.Gear:
      return <Gear />;
    case IconVariant.Google:
      return <Google />;
    case IconVariant.Heart:
      return <Heart />;
    case IconVariant.Home:
      return <Home />;
    case IconVariant.HomeFilled:
      return <HomeFilled />;
    case IconVariant.Instagram:
      return <Instagram />;
    case IconVariant.List:
      return <List />;
    case IconVariant.ListFilled:
      return <ListFilled />;
    case IconVariant.Lock:
      return <Lock />;
    case IconVariant.MagnifyingGlass:
      return <MagnifyingGlass />;
    case IconVariant.MagnifyingGlassFilled:
      return <MagnifyingGlassFilled />;
    case IconVariant.Minus:
      return <Minus />;
    case IconVariant.Never:
      return <Never />;
    case IconVariant.New:
      return <New />;
    case IconVariant.Pause:
      return <Pause />;
    case IconVariant.Pencil:
      return <Pencil />;
    case IconVariant.Pepper:
      return <Pepper />;
    case IconVariant.Pepper2:
      return <Pepper2 />;
    case IconVariant.Person:
      return <Person />;
    case IconVariant.PersonFilled:
      return <PersonFilled />;
    case IconVariant.Platter:
      return <Platter />;
    case IconVariant.Play:
      return <Play />;
    case IconVariant.PlusCircle:
      return <PlusCircle />;
    case IconVariant.Plus:
      return <Plus />;
    case IconVariant.Question:
      return <Question />;
    case IconVariant.RadioOff:
      return <RadioOff />;
    case IconVariant.RadioOn:
      return <RadioOn />;
    case IconVariant.Servings:
      return <Servings />;
    case IconVariant.Slider:
      return <Slider />;
    case IconVariant.Sparkle:
      return <Sparkle />;
    case IconVariant.StarFill:
      return <StarFill />;
    case IconVariant.StarOutline:
      return <StarOutline />;
    case IconVariant.Sunrise:
      return <Sunrise />;
    case IconVariant.Swap:
      return <Swap />;
    case IconVariant.Tag:
      return <Tag />;
    case IconVariant.Trash:
      return <Trash />;
    case IconVariant.Trash2:
      return <Trash2 />;
    case IconVariant.Twitter:
      return <Twitter />;
    case IconVariant.X:
      return <X />;
    case IconVariant.YouTube:
      return <Youtube />;
    case IconVariant.ThumbsDown:
      return <ThumbsDown />;
    case IconVariant.ThumbsDownFilled:
      return <ThumbsDownFilled />;
    case IconVariant.ThumbsUp:
      return <ThumbsUp />;
    case IconVariant.ThumbsUpFilled:
      return <ThumbsUpFilled />;
    case IconVariant.Truck:
      return <Truck />;
    case IconVariant.Bookmark:
      return <Bookmark />;
    case IconVariant.Wallet:
      return <Wallet />;
    case IconVariant.Information:
      return <Information />;
    case IconVariant.ChefHat:
      return <ChefHat />;
    case IconVariant.Fish:
      return <Fish />;
    case IconVariant.Vegetarian2:
      return <Vegetarian2 />;
    case IconVariant.Vegan2:
      return <Vegan2 />;

    // illustrated
    case IconVariant.Airfryer:
      return <Airfryer />;
    case IconVariant.AntiInflamitory:
      return <AntiInflamitory />;
    case IconVariant.BeansPlusLentils:
      return <BeansPlusLentils />;
    case IconVariant.Beef:
      return <Beef />;
    case IconVariant.Beets:
      return <Beets />;
    case IconVariant.BellPepper:
      return <BellPepper />;
    case IconVariant.NoBellPepper:
      return <NoBellPepper />;
    case IconVariant.Blender:
      return <Blender />;
    case IconVariant.Breakfast:
      return <Breakfast />;
    case IconVariant.Burger:
      return <Burger />;
    case IconVariant.Calendar:
      return <Calendar />;
    case IconVariant.Calories:
      return <Calories />;
    case IconVariant.CalorieConscious:
      return <CalorieConscious />;
    case IconVariant.ChefsPick:
      return <ChefsPick />;
    case IconVariant.Chicken:
      return <Chicken />;
    case IconVariant.Cilantro:
      return <Cilantro />;
    case IconVariant.NoCilantro:
      return <NoCilantro />;
    case IconVariant.ClockIllustrated:
      return <ClockIllustrated />;
    case IconVariant.Coconut:
      return <Coconut />;
    case IconVariant.Credit:
      return <Credit />;
    case IconVariant.Crockpot:
      return <Crockpot />;
    case IconVariant.Cuisines:
      return <Cuisines />;
    case IconVariant.CYO:
      return <Cyo />;
    case IconVariant.DairyFree:
      return <DairyFree />;
    case IconVariant.DairyFreeCheese:
      return <DairyFreeCheese />;
    case IconVariant.Dietary:
      return <Dietary />;
    case IconVariant.Dislike:
      return <Dislike />;
    case IconVariant.EggFree:
      return <EggFree />;
    case IconVariant.Eggplant:
      return <Eggplant />;
    case IconVariant.NoEggplant:
      return <NoEggplant />;
    case IconVariant.FreshFish:
      return <FreshFish />;
    case IconVariant.Garlic:
      return <Garlic />;
    case IconVariant.Gift:
      return <Gift />;
    case IconVariant.GlutenFree:
      return <GlutenFree />;
    case IconVariant.GlutenFreeBread:
      return <GlutenFreeBread />;
    case IconVariant.Grill:
      return <Grill />;
    case IconVariant.GutFriendly:
      return <GutFriendly />;
    case IconVariant.GutHealth:
      return <GutHealth />;
    case IconVariant.HighFiber:
      return <HighFiber />;
    case IconVariant.HighProtein:
      return <HighProtein />;
    case IconVariant.Immunity:
      return <Immunity />;
    case IconVariant.IllustrationDietary:
      return <IllustrationDietary />;
    case IconVariant.Lamb:
      return <Lamb />;
    case IconVariant.LowFat:
      return <LowFat />;
    case IconVariant.LowCholesterol:
      return <LowCholesterol />;
    case IconVariant.LowFodmap:
      return <LowFodmap />;
    case IconVariant.Microwave:
      return <Microwave />;
    case IconVariant.Mushrooms:
      return <Mushrooms />;
    case IconVariant.NoMushrooms:
      return <NoMushrooms />;
    case IconVariant.NewIllustrated:
      return <NewIllustrated />;
    case IconVariant.Nutrition:
      return <Nutrition />;
    case IconVariant.Onion:
      return <Onion />;
    case IconVariant.NoOnion:
      return <NoOnion />;
    case IconVariant.Organic:
      return <Organic />;
    case IconVariant.Organic2:
      return <Organic2 />;
    case IconVariant.PeanutFree:
      return <PeanutFree />;
    case IconVariant.Personalized:
      return <Personalized />;
    case IconVariant.Pescatarian:
      return <Pescatarian />;
    case IconVariant.PlantBased:
      return <PlantBased />;
    case IconVariant.PlantBasedEgg:
      return <PlantBasedEgg />;
    case IconVariant.Polarizing:
      return <Polarizing />;
    case IconVariant.Pork:
      return <Pork />;
    case IconVariant.Potatoes:
      return <Potatoes />;
    case IconVariant.NoPotatoes:
      return <NoPotatoes />;
    case IconVariant.Protein:
      return <Protein />;
    case IconVariant.Recent:
      return <Recent />;
    case IconVariant.Recipe:
      return <Recipe />;
    case IconVariant.Shellfish:
      return <Shellfish />;
    case IconVariant.ShellfishFree:
      return <ShellfishFree />;
    case IconVariant.SmokedFish:
      return <SmokedFish />;
    case IconVariant.SoyFree:
      return <SoyFree />;
    case IconVariant.Spice:
      return <Spice />;
    case IconVariant.SpiceHot:
      return <SpiceHot />;
    case IconVariant.SpiceMedium:
      return <SpiceMedium />;
    case IconVariant.SpiceMild:
      return <SpiceMild />;
    case IconVariant.SpiceNone:
      return <SpiceNone />;
    case IconVariant.Stove:
      return <Stove />;
    case IconVariant.Tempeh:
      return <Tempeh />;
    case IconVariant.Tomatoes:
      return <Tomatoes />;
    case IconVariant.NoTomatoes:
      return <NoTomatoes />;
    case IconVariant.TreeNutFree:
      return <TreeNutFree />;
    case IconVariant.Vegan:
      return <Vegan />;
    case IconVariant.Vegetarian:
      return <Vegetarian />;
    case IconVariant.KidsSnacks:
      return <KidsSnacks />;

    case IconVariant.Feeds1:
      return <Feeds1 />;
    case IconVariant.Feeds2:
      return <Feeds2 />;
    case IconVariant.Feeds3:
      return <Feeds3 />;
    case IconVariant.Feeds4:
      return <Feeds4 />;
    case IconVariant.StoveTop:
      return <StoveTop />;
    case IconVariant.Oven:
      return <Oven />;

    case IconVariant.Flavors:
      return <Flavors />;
    case IconVariant.FreeShipping:
      return <FreeShipping />;
    case IconVariant.SpendMoreSaveMore:
      return <SpendMoreSaveMore />;
    case IconVariant.ThirtyOff:
      return <ThirtyOff />;
    case IconVariant.OpenBox:
      return <OpenBox />;
    case IconVariant.Sweets:
      return <Sweets />;
    case IconVariant.Sweets2:
      return <Sweets2 />;
    case IconVariant.Snacks:
      return <Snacks />;
    case IconVariant.TableSetting:
      return <TableSetting />;
    case IconVariant.WalletIllustrated:
      return <WalletIllustrated />;
    case IconVariant.Lightbulb:
      return <Lightbulb />;
    case IconVariant.LowCarb:
      return <LowCarb />;
    case IconVariant.LowSodium:
      return <LowSodium />;
    case IconVariant.LowSugar:
      return <LowSugar />;
    case IconVariant.XCircle:
      return <XCircle />;
    case IconVariant.Warning:
      return <Warning />;

    case IconVariant.None:
      return <None />;
    case IconVariant.Sweets23:
      return <Sweets23 />;
    case IconVariant.Sweets46:
      return <Sweets46 />;
    case IconVariant.Sweets710:
      return <Sweets710 />;

    case IconVariant.SesameFree:
      return <SesameFree />;
    case IconVariant.GrainFree:
      return <GrainFree />;
    case IconVariant.GarlicFree:
      return <GarlicFree />;
    case IconVariant.OnionFree:
      return <OnionFree />;
    case IconVariant.CaffeineFree:
      return <CaffeineFree />;
  }
}
